import React, { useContext, useState } from 'react';
import FormBtn from '../../Form/FormBtn';
import TextArea from '../../Form/TextArea';
import TextField from '../../Form/TextField';
import Swal from 'sweetalert2';
import AuthContext from '../../../store/auth-context';

const AddAdminExperience = ({ onClickData, popupChangeHandler }) => {
  const context = useContext(AuthContext);
  const [year, setYear] = useState(onClickData ? onClickData.year : '');
  const [role, setRole] = useState(onClickData ? onClickData.role : '');
  const [shortDescription, setShortDescription] = useState(
    onClickData ? onClickData.description.shortDescription : ''
  );
  const [bullets, setBullets] = useState(
    onClickData ? onClickData.description.bullets.join(';') : []
  );

  const yearChangeHandler = (event) => {
    setYear(event);
  };
  const roleChangeHandler = (event) => {
    setRole(event);
  };
  const shortDescriptionHandler = (event) => {
    setShortDescription(event);
  };

  const bulletsChangeHandler = (event) => {
    setBullets(event);
  };
  const onFormSubmit = (event) => {
    event.preventDefault();

    /* 
    `${
        'https://aifolio-api.herokuapp.com/' || 'https://aifolio-api.herokuapp.com'
      }/api/user/add/`
       */

    fetch('https://aifolio-api.herokuapp.com/api/user/add', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({
        workExperience: {
          year: year,
          role: role,
          description: {
            shortDescription: shortDescription,
            bullets: bullets.toString().split(';'),
          },
        },
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setYear('');
          setRole('');
          setShortDescription('');
          setBullets('');

          Swal.fire({
            icon: 'success',
            title: 'Successfully added project',
            timer: 1000,
          });

          context.newReqHandler();
        }
      })
      .catch((err) => console.log(err));
  };

  const onEditSubmit = (e) => {
    e.preventDefault();

    fetch(
      `https://aifolio-api.herokuapp.com/api/user/update/${onClickData._id}`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          id: onClickData._id,
          workExperience: {
            year: year,
            role: role,
            description: {
              shortDescription: shortDescription,
              bullets: bullets.toString().split(';'),
            },
          },
        }),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setYear('');
          setRole('');
          setShortDescription('');
          setBullets('');

          Swal.fire({
            icon: 'success',
            title: 'Successfully added project',
            timer: 1000,
          });

          context.newReqHandler();

          popupChangeHandler(false);
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <form
      onSubmit={onClickData ? onEditSubmit : onFormSubmit}
      className='w-80 me-3'
    >
      <TextField
        label='year'
        inputHandler={yearChangeHandler}
        value={year}
        type='text'
      />
      <TextField
        label='role'
        inputHandler={roleChangeHandler}
        value={role}
        type='text'
      />
      <TextArea
        label='shortDescription'
        inputHandler={shortDescriptionHandler}
        value={shortDescription}
        row='5'
        col='5'
      />
      <TextArea
        label='bullets'
        inputHandler={bulletsChangeHandler}
        value={bullets}
        row='5'
        col='5'
      />

      <FormBtn value='Save' type='submit' />
    </form>
  );
};

export default AddAdminExperience;
